import loadingReducer from './loadingReducer';

export default loadingReducer;
